import { useWorkflowCanvasBinding } from '../../workflow-editor';
import { BuilderChatPanel, TBuilderChatPanelProps } from './BuilderChatPanel';
import { WorkflowBuilderLayoutHelper } from './helpers/workflow-builder-layout-helper';

type TBuilderAgentColumnProps = Omit<TBuilderChatPanelProps, 'canvas'>;

/** The builder agent as the column {@link WorkflowBuilderAgentLayout} places beside the editor. It
 * reads canvas state itself rather than through the editor's `renderChatPanel`, because that slot
 * renders inside the editor and would start below the toolbar. */
export const BuilderAgentColumn = (props: TBuilderAgentColumnProps) => {
  const canvas = useWorkflowCanvasBinding();

  return (
    <aside
      className="h-full shrink-0 overflow-hidden bg-bg-light"
      style={{
        width: `${WorkflowBuilderLayoutHelper.AGENT_COLUMN_WIDTH_PX}px`,
      }}
    >
      <BuilderChatPanel {...props} canvas={canvas} />
    </aside>
  );
};
